import React, { useContext, useRef, useEffect } from "react";
import StoreContext from "@/context/root-store";
import { observer } from "mobx-react";
import banner1 from "../../../img/banner-home/banner10.jpg";
import banner2 from "../../../img/banner-home/banner-2.png";
import banner3 from "../../../img/banner-home/banner-3.png";
import banner4 from "../../../img/banner-home/banner-4.svg";
import banner5 from "../../../img/banner-home/banner-5.svg";
// @ts-ignore
import CustomSlider from "../../CustomSlider.jsx";
// @ts-ignore
import videoLogo from "../../../video/videoLogoPdG.mp4";
var Home = observer(function (props) {
  var homeStore = useContext(StoreContext).rootStore.homeStore;
  var rootStore = useContext(StoreContext).rootStore;
  var isMounted = useRef(false);
  var $ = require('jquery');
  useEffect(function () {
    document.title = "Certificazione della parità di genere";
    $("#ita.list-inline-item").addClass("active");
    $("#eng.list-inline-item").removeClass("active");
  });
  return rootStore.uiStore.numberCallback === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row m-0 p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bgColorGrayLight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("video", {
    loop: true,
    autoPlay: true,
    muted: true,
    className: "w-100 h-100"
  }, /*#__PURE__*/React.createElement("source", {
    src: videoLogo,
    type: "video/mp4"
  }), "Your browser does not support the video tag."), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "logo in movimento del sito Certificazione della parit\xE0 di genere"))))), /*#__PURE__*/React.createElement("section", {
    className: "section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "fontColorText mb-5"
  }, "Notizie"), /*#__PURE__*/React.createElement(CustomSlider, null))), /*#__PURE__*/React.createElement("section", {
    className: "section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row m-0 p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-0 pt-5 pl-0 col-sm-12 col-xl-4 image-container text-center "
  }, /*#__PURE__*/React.createElement("img", {
    className: "customPositionImage fluid",
    src: banner1,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-xl-8 bgColorGrayLight paddingText1 customSM"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "fontColorText"
  }, "A cosa serve la certificazione"), /*#__PURE__*/React.createElement("p", {
    className: "paddingRight"
  }, "La finalit\xE0 del Sistema di certificazione della parit\xE0 di genere alle imprese \xE8 quella di favorire l\u2019adozione di politiche per la parit\xE0 di genere e per l\u2019empowerment femminile a livello aziendale e quindi di migliorare la possibilit\xE0 per le donne di accedere al mercato del lavoro, di leadership e di armonizzazione dei tempi vita."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: function onClick() {
      window.location.href = process.env.CONTEXT_PATH + "/a-cosa-serve";
    }
  }, "SCOPRI DI PI\xD9"), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "bottone scopri di pi\xF9")))))), /*#__PURE__*/React.createElement("section", {
    className: "section bgColorGrayLight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row m-0 p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-md-6 paddingText1 pl-0 d-flex flex-column justify-content-center"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "fontColorText"
  }, "Come ottenere la certificazione"), /*#__PURE__*/React.createElement("p", {
    className: "paddingRight"
  }, "La certificazione avviene su base ", /*#__PURE__*/React.createElement("b", null, "volontaria"), " e su ", /*#__PURE__*/React.createElement("b", null, "richiesta dell\u2019impresa"), ". Al rilascio della certificazione provvedono gli organismi di certificazione accreditati che operano sulla base della prassi UNI/PdR 125:2022."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: function onClick() {
      window.location.href = process.env.CONTEXT_PATH + "/certificazione";
    }
  }, "SCOPRI DI PI\xD9"), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "bottone scopri di pi\xF9"))), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-md-6 py-5 pl-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row m-0 p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-lg-5 col-xxl-4 text-center"
  }, /*#__PURE__*/React.createElement("img", {
    className: "fluidIcone",
    src: banner2,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-lg-7 ml-xxl-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row mt-6 mt-xl-6 customPositionText"
  }, /*#__PURE__*/React.createElement("p", {
    className: "formattaDatiCert"
  }, "16.308")), /*#__PURE__*/React.createElement("div", {
    className: "row mt-3 customPositionText"
  }, /*#__PURE__*/React.createElement("p", {
    className: "formattaDatiCert2"
  }, "Certificazioni rilasciate")))), /*#__PURE__*/React.createElement("div", {
    className: "row m-0 p-0 mt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-lg-5 col-xxl-4 text-center"
  }, /*#__PURE__*/React.createElement("img", {
    className: "fluidIcone",
    src: banner3,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-lg-7 ml-xxl-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row mt-6 mt-xl-6 customPositionText"
  }, /*#__PURE__*/React.createElement("p", {
    className: "formattaDatiCert"
  }, "65")), /*#__PURE__*/React.createElement("div", {
    className: "row mt-3 customPositionText"
  }, /*#__PURE__*/React.createElement("p", {
    className: "formattaDatiCert2"
  }, "Organismi di certificazione")))))))), /*#__PURE__*/React.createElement("section", {
    className: "section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row m-0 p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-lg-6 pl-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-text-center"
  }, /*#__PURE__*/React.createElement("img", {
    className: "fluid",
    src: banner4,
    alt: ""
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-lg-6 paddingText1 pl-0 d-flex flex-column justify-content-center"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "fontColorText"
  }, "Contributi"), /*#__PURE__*/React.createElement("p", {
    className: ""
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: function onClick() {
      window.location.href = process.env.CONTEXT_PATH + "/contributi";
    }
  }, "SCOPRI DI PI\xD9"), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "bottone scopri di pi\xF9")))))), /*#__PURE__*/React.createElement("section", {
    className: "section bgColorGrayLight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row m-0 p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-lg-6 paddingText1 pl-0 custom-text-center mb-5"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "fontColorText"
  }, "Vuoi saperne di pi\xF9 ?"), /*#__PURE__*/React.createElement("h2", {
    className: "fontColorText"
  }, "Leggi le domande frequenti"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary mt-5",
    onClick: function onClick() {
      window.location.href = process.env.CONTEXT_PATH + "/faq";
    }
  }, "VAI ALLE FAQ"), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "bottone scopri di pi\xF9"))), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-lg-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("img", {
    className: "fluid mt-5",
    src: banner5,
    alt: ""
  })))))));
});
export default Home;